import axios from 'axios'
const request = axios.create({
    timeout: 20000
})

const baseUrlNewbaseZhihuishu = 'https://newbase.zhihuishu.com/'
// 有些接口同投屏端一致：
const baseUrlSimpleClassZhihuishu = 'https://simple-class.zhihuishu.com/'
const baseUrlOnlineserviceZhihuishu = 'https://onlineservice.zhihuishu.com/'
// 注意：纯极简关于声网这里，张颖接口通过域名的不同来区分环境，preview的为预发，cloud的为产线
// 由于本项目的地址为http://www.livecourse.com/school/，预发产线通过配置host区分，所以此接口域名无法灵活配置
// const baseUrlPreviewOrCloudLivecourse = 'https://preview.livecourse.com/' //预发
const baseUrlPreviewOrCloudLivecourse = 'https://cloud.livecourse.com/' //产线
const baseUrlStateLivecourse = 'https://state.livecourse.com/'

// 查看视频地址：
const getVideoById = (params) => {
    return request({
        baseURL: baseUrlNewbaseZhihuishu,
        url: `video/initVideo`,
        method: 'get',
        params
    })
}

// 查看视频地址，新的：
const getVideoByIdNew = (params) => {
    return request({
        baseURL: baseUrlNewbaseZhihuishu,
        url: `video/initVideoNew`,
        method: 'get',
        params
    })
}

//获取课程信息：
const liveClassShareLive = params => {
  return request({
    baseURL: baseUrlSimpleClassZhihuishu,
    url: `liveClass/shareLive`,
    method: 'get',
    params
  })
}

// 获取服务器时间:
const getServerTime = () => {
    return request({
        baseURL: baseUrlOnlineserviceZhihuishu,
        url: `student/home/index/getServerTime`,
        method: 'get'
      })
}

// 获取声网信息--拉流用:
const getSimpleclassTokenForSubscriber = params => {
    return request({
        baseURL: baseUrlPreviewOrCloudLivecourse,
        url: `vrClass/SimpleclassTokenForSubscriber`,
        method: 'get',
        params
    })
}

/**
 * @description: 获取声网token值
 * @param {*}
 * @return {*}
 */
const getAgaroToken = params => {
    return request({
        baseURL: baseUrlPreviewOrCloudLivecourse,
        url: `vrClass/listTokenForClassroom`,
        method: 'post',
        data: params
    })
}

/**
 * @description: 获取LC状态机数据
 * @param {*}
 * @return {*}
 */
const getStateMachine = params => {
    return request({
        baseURL: baseUrlStateLivecourse,
        url: `info`,
        method: 'get',
        params
    })
}

export default {
    getStateMachine,
    getAgaroToken,
    getVideoById,
    getVideoByIdNew,
    liveClassShareLive,
    getServerTime,
    getSimpleclassTokenForSubscriber
}